import { useEffect, useState } from 'react';
import { AppointmentApi, AppointmentDto } from '../http';

interface Options {
  uuid: string;
  onSuccess?: (values: any) => void;
  onError?: (error: any) => void;
}

const appointmentApi = new AppointmentApi();

export const useAppointmentDetail = ({ uuid }: Options) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [data, setData] = useState<AppointmentDto>();

  useEffect(() => {
    setIsLoading(true);
    appointmentApi
      .findOne(uuid)
      .then((response: AppointmentDto) => {
        setData(response);
        setIsLoading(false);
      })
      .catch((e) => {
        setErrors(e.errorMessage);
      });
  }, []);

  return {
    data,
    isLoading,
    errors
  };
};
